<template>
  <div class="container">
    <div class="container page_banner ">
      <div class='page_width'>
         <div class="banner_gruop" >
            <div class="banner_title"> <span class="color3"></span> Retail Payments That Scale</div>
            <div class="banner_tips mt-40 fw-300">Transform your retail business with modern payment infrastructure. Focus on scaling while we handle seamless, secure transactions.</div>
         </div>
       </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
            <div class="page_title pb-30">
                <div class="title_name color1 ">Why Corelinkpay for Retail?</div> 
            </div>
            <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12" v-for="tab in tabList" :key="tab.id">
                    <div class="tab_left text-l border-card p-20 h-100p card_bg">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img :src="tab.icon" alt="" class="">
                        </div>
                        <div class="half_title color1">{{ tab.title }}</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">{{ tab.msg }}</div>
                    </div>
                </div>
              </div>
          </div>  
      
        </div>
      </div>
    </div>
    <div class="container bg_2"> 
      <div class="" >
        <div class="page_width" >
        
           <div class="py-80" >
            <div class="page_title ">
                <div class="title_name color1 ">FAQs</div>   
            </div>
            <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_12 grid_xs_12 grid_sm_12 ">
                     <div class="faq_collapse">
                        <el-collapse v-model="activeName" accordion>
                          <el-collapse-item title="How fast are transactions processed?" name="1">
                            <div class="coll_item">CorelinkPay ensures instant transactions, with funds reflecting in your account within minutes.</div> 
                          </el-collapse-item>
                          <el-collapse-item title="Is CorelinkPay secure for retail payments?" name="2">
                           <div class="coll_item">Yes, our platform is PCI DSS-compliant, featuring top-tier encryption and fraud prevention measures.</div>
                          </el-collapse-item>
                          <el-collapse-item title="Can CorelinkPay support international customers?" name="3">
                           <div class="coll_item">Absolutely. Our multi-currency support makes it easy to serve customers globally.</div>
                          </el-collapse-item>
                          <el-collapse-item title="How does CorelinkPay help growing businesses?" name="4">
                           <div class="coll_item">Our scalable plans and intuitive APIs allow you to bring products to market quickly and adapt to your business’s evolving needs.</div>
                          </el-collapse-item>
                        </el-collapse>
                      </div>
                </div>
                

            </div>
          </div>
          
        </div>
      </div>
      
    </div>
    <div class="container">
        <div class="page_width">
          <div class="pt-30 pb-80">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                  <div class="w-100p">
                    <img src="../../assets/image/t55.png" alt="">
                  </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                    <div class="page_title ">
                        <div class="title_name text-l">Elevate Your Retail Business with CorelinkPay</div>
                        <div class="title_tag  text-l">Our scalable plans and intuitive APIs allow you to bring products to market quickly and adapt to your business’s evolving needs.</div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>

   
  </div>
</template>

<script>





import tab1 from '../../assets/image/tb28.png'
import tab2 from '../../assets/image/tb29.png'
import tab3 from '../../assets/image/tb30.png'
import tab4 from '../../assets/image/tb31.png'
import tab5 from '../../assets/image/tb32.png'
import tab6 from '../../assets/image/tb33.png'

export default {
    data(){
        return{
           
          
            activeName:'1',
            tabList:[
                {title:"Seamless Open Banking",msg:'Deliver a superior customer experience with secure, fast, and smooth transactions powered by open banking, connecting you to major banks across the UK and EU.',id:1,icon:tab1},

                {title:"AI-Driven Insights",msg:'Unlock powerful analytics with CorelinkPay’s AI/ML tools. Deepen customer behavior insights via segmentation, forecasting, and actionable data for smarter decisions.',id:4,icon:tab4},
                {title:"Multi-Currency Support",msg:'Cater to a global audience with CorelinkPay’s support for multiple currencies, ensuring effortless transactions for customers worldwide.',id:3,icon:tab3},
                {title:"Uncompromising Security",msg:'Shop with confidence. CorelinkPay’s PCI DSS-compliant gateway offers robust encryption and fraud prevention to protect your business and customers.',id:2,icon:tab2},
                
                {title:"Scalable Solutions",msg:'From small boutiques to large retail chains, our flexible plans are designed to grow with your business, providing tailored payment solutions for every stage.',id:6,icon:tab6},
                {title:"Effortless Payment Processing",msg:'Streamline pay-ins and pay-outs with intuitive UX, smart transaction routing, and a wide range of popular payment methods to enhance customer satisfaction.',id:5,icon:tab5},
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.page_banner{
    background-image:url( ../../../public/bg/bn_bg9.png);
}
.half_title{
   font-size: 30px;
}
.half_text{
   font-size: 18px;
}


</style>